const GEOSERVER_URL = `https://api.cscrs.itu.edu.tr/gis-agriculture`;
const GEOSERVER_WMS_URL = `${GEOSERVER_URL}/wms`;
const GEOSERVER_WMS_GETCAPABILITIES = `${GEOSERVER_WMS_URL}?request=getCapabilities`;
const GEOSERVER_WMS_PARCEL_LEGEND = `${GEOSERVER_WMS_URL}?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER=Tarim:parsel`;
const GEOSERVER_WMS_MAHSUL_LEGEND = `${GEOSERVER_WMS_URL}?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER=Tarim:mahsul`;

// GeoServer Authentication
const GEOSERVER_USERNAME = 'admin';
const GEOSERVER_PASSWORD = 'GeoAgriculture2024!Secure';

export {
  GEOSERVER_URL,
  GEOSERVER_WMS_URL,
  GEOSERVER_WMS_GETCAPABILITIES,
  GEOSERVER_WMS_PARCEL_LEGEND,
  GEOSERVER_WMS_MAHSUL_LEGEND,
  GEOSERVER_USERNAME,
  GEOSERVER_PASSWORD,
};
